import { useState } from "react";
import { Alert, Box, Button, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { acceptContract } from "services/contracts";
import { signOutFirebase } from "services/firebase";

export default function ContractAcceptance({ contract, onAccepted, onReload }) {
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async () => {
    setBusy(true);
    setError("");
    try {
      await acceptContract(contract);
      await onAccepted();
    } catch (failure) {
      setError(failure.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Stack spacing={2}>
      {error && (
        <Alert severity="error" action={<Button onClick={onReload}>Recarregar</Button>}>
          {error}
        </Alert>
      )}
      <Box sx={{ p: 2, borderRadius: 2, bgcolor: "#f2f8f3", border: "1px solid #dbeade" }}>
        <FormControlLabel
          sx={{ m: 0, alignItems: "flex-start" }}
          control={
            <Checkbox
              sx={{ pt: 0 }}
              checked={checked}
              disabled={busy}
              onChange={(event) => setChecked(event.target.checked)}
            />
          }
          label="Li o documento desta versão e aceito seus termos."
        />
      </Box>
      <Stack
        direction={{ xs: "column-reverse", sm: "row" }}
        justifyContent="space-between"
        spacing={2}
      >
        <Button
          disabled={busy}
          onClick={() => signOutFirebase().catch((failure) => setError(failure.message))}
        >
          Não aceito — sair
        </Button>
        <Button
          variant="contained"
          color="success"
          disabled={!checked || busy}
          onClick={submit}
          sx={{ px: 3 }}
        >
          {busy ? "Registrando aceite..." : "Aceito o contrato"}
        </Button>
      </Stack>
    </Stack>
  );
}
